import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenisSmoothScroll } from "@/hooks/useLenis";
import Home from "@/pages/Home";
import TrainingDetail from "@/pages/TrainingDetail";
import GovernmentPrograms from "@/pages/GovernmentPrograms";
import ServiceDetail from "@/pages/ServiceDetail";
import { c408Config, kingAirConfig } from "@/pages/trainingConfigs";
import { serviceConfigs } from "@/pages/serviceConfigs";

function AppShell() {
  useLenisSmoothScroll();
  return (
    <div className="App bg-[#050505] text-white grain min-h-screen" data-testid="app-root">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/training/c408"
          element={<TrainingDetail config={c408Config} />}
        />
        <Route
          path="/training/king-air"
          element={<TrainingDetail config={kingAirConfig} />}
        />
        <Route path="/programs/government" element={<GovernmentPrograms />} />
        <Route
          path="/services/contract-pilot"
          element={<ServiceDetail config={serviceConfigs["contract-pilot"]} />}
        />
        <Route
          path="/services/aircraft-delivery"
          element={<ServiceDetail config={serviceConfigs["aircraft-delivery"]} />}
        />
        <Route
          path="/services/owner-mentoring"
          element={<ServiceDetail config={serviceConfigs["owner-mentoring"]} />}
        />
        <Route
          path="/services/aircraft-management"
          element={<ServiceDetail config={serviceConfigs["aircraft-management"]} />}
        />
      </Routes>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0A0C",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#F3F4F6",
            borderRadius: "0px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
